import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { useParams, useHistory } from "react-router-dom";
import ThreeSlotMachineDetailCard from "./components/ThreeSlotMachineDetailCard";
import { DUMMY_LOTTERIES } from "./ThreeSlotLottery";
import NavBar from "../../../Components/NavBar";
import { connectWallet as triggerConnectWallet } from "../../../../static/walletUtils";

const ThreeSlotLotteryDetails = () => {
  const { id } = useParams();
  const history = useHistory();

  const [account, setAccount] = useState("");
  const [isCheckingWallet, setIsCheckingWallet] = useState(true);

  // User-specific values
  const [balance, setBalance] = useState("1250.00");
  const [win, setWin] = useState("0.00");

  // Find the lottery using the ID from the URL or contract
  const [lotteryData] = useState(() => {
    const found = DUMMY_LOTTERIES.find((lottery) => lottery.lotteryId.toString() === id);
    return (
      found || {
        lotteryId: id || 101,
        name: `3-SlotBET #${id || 101}`,
        creator: "AutoBET Official",
        slotCategory: "fiat",
        jackpots: {
          mini: { amount: "1000.00", seedValue: "500.00", contributionPerSpin: "0.020" },
          major: { amount: "10000.00", seedValue: "5000.00", contributionPerSpin: "0.008" },
          mega: { amount: "50000.00", seedValue: "20000.00", contributionPerSpin: "0.002" },
        },
      }
    );
  });

  // Check whether a wallet is already connected
  useEffect(() => {
    const checkWalletConnection = async () => {
      if (!window.ethereum) {
        setIsCheckingWallet(false);
        return;
      }

      try {
        const accounts = await window.ethereum.request({
          method: "eth_accounts",
        });

        if (accounts && accounts.length > 0) {
          setAccount(accounts[0]);
        }
      } catch (error) {
        console.error("Failed to check wallet connection:", error);
      } finally {
        setIsCheckingWallet(false);
      }
    };

    checkWalletConnection();
  }, []);

  // Listen for wallet changes
  useEffect(() => {
    if (!window.ethereum) return;

    const handleAccountsChanged = (accounts) => {
      setAccount(accounts?.[0] || "");
    };

    window.ethereum.on("accountsChanged", handleAccountsChanged);

    return () => {
      window.ethereum.removeListener("accountsChanged", handleAccountsChanged);
    };
  }, []);

  const handleConnectWallet = async () => {
    const res = await triggerConnectWallet();
    if (res.account) {
      setAccount(res.account);
    }
  };

  if (isCheckingWallet) {
    return null;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#060a14",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />
      <Container
        maxWidth="lg"
        sx={{
          pt: { xs: "80px", sm: "96px", md: "104px" },
          pb: { xs: 4, md: 8 },
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 540,
            mb: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => history.push("/three-slotlottery")}
            sx={{
              color: "#94a3b8",
              textTransform: "none",
              fontWeight: 800,
              fontSize: "0.92rem",
              px: 1,
              py: 0.5,
              borderRadius: "8px",
              bgcolor: "rgba(255, 255, 255, 0.05)",
              "&:hover": {
                bgcolor: "rgba(234, 179, 8, 0.15)",
                color: "#f59e0b",
              },
            }}
          >
            Back to Arena
          </Button>

          {!account && (
            <Button
              size="small"
              startIcon={<AccountBalanceWalletIcon />}
              onClick={handleConnectWallet}
              sx={{
                color: "#fef08a",
                bgcolor: "rgba(234, 179, 8, 0.15)",
                border: "1px solid rgba(234, 179, 8, 0.4)",
                borderRadius: "16px",
                textTransform: "none",
                fontWeight: 800,
                fontSize: "0.82rem",
                px: 1.75,
                py: 0.5,
                "&:hover": {
                  bgcolor: "rgba(234, 179, 8, 0.3)",
                },
              }}
            >
              Connect Wallet
            </Button>
          )}
        </Box>

        {/* The 3-Slot Pokies Mobile-first Interface */}
        <Box sx={{ width: "100%", maxWidth: 540 }}>
          <ThreeSlotMachineDetailCard
            lotteryData={lotteryData}
            account={account}
            balance={balance}
            win={win}
            setBalance={setBalance}
            setWin={setWin}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default ThreeSlotLotteryDetails;